import { ComponentContainer, LayoutGrid } from "../LayoutContainers";
import OnlyText from "../OnlyText";

export default function OpenYourAccount({ data }) {
    const { tag, title, theme, description, image, cta } = data || {};

    return (
        <ComponentContainer image={`${window._env_.STATIC_HOST}/static/website/images/bg-cotizaciones.jpg`}>
            <LayoutGrid spacingTop="8" spacingBottom="8" cols={1}>
                <OnlyText
                    tag={tag}
                    title={title}
                    description={description}
                    contentAlign="center"
                    cta={cta}
                    theme={theme}
                    classNames={"open-your-account"}
                />
            </LayoutGrid>
        </ComponentContainer>
    );
}
